<template>
    <div>
        <Modal
            v-model="visible"
            title="数据权限"
            :loading="$root.$children[0].modalLoading"
            width="600"
            :mask-closable="false"
            :footer-hide="true"
            class="my-modal top"
        >
            <Form v-if="visible" ref="form" :model="formData" class="page-form form-container">
                <FormItem class="full" label="登录账号" style="margin-left:8px;" :label-width="70">
                    <span class="user-name">{{ formData.account }}</span>
                </FormItem>

                <FormItem class="full" prop="dataType" label :label-width="100" :rules="$units.formRule.required('请选择数据权限')">
                    <span slot="label" class="label">
                        数据权限<span class="tip-icon">?</span>
                        <div class="pop-tip">
                            <span>本级机构及下级机构：支持查看当前及所有下级机构数据</span><br />
                            <span>单独配置：自行配置此账号查看的数据范围，未勾选机构不可查看数据</span>
                            <div class="arrow"></div>
                        </div>
                    </span>

                    <RadioGroup v-model="formData.dataType" @on-change="changeOrgSetUp" style="margin-top:-1px;">
                        <Radio label="1">本机构及下级机构</Radio>
                        <Radio label="2">单独设置</Radio>
                    </RadioGroup>
                </FormItem>

                <FormItem label="简洁模式" prop="supervise" :label-width="77" v-if="$units.superviseShowVal()">
                    <RadioGroup v-model="formData.supervise">
                        <Radio label="0">否</Radio>
                        <Radio label="1">是</Radio>                        
                    </RadioGroup>
                </FormItem>

                <FormItem
                    class="full"
                    prop="dataOrgIds"
                    key="dataOrgIds"
                    :label-width="0"
                    :rules="$units.formRule.arrRequired('请选择')"
                    v-if="formData.dataType == '2'"
                >   
                    <selectTree
                        v-model="formData.dataOrgIds"
                        :multiple="true"
                        type="4"
                        ref="selectTreeRef"
                        :orgId="buzOrganId"
                        :checkChild="false"
                        @treeClick="treeClick"
                        @getTreeData="getTreeData"
                        :showCloseIcon="false"
                    ></selectTree>
                </FormItem>
            </Form>

            <div class="ivu-modal-footer">
                <Button type="text" @click="visible = false">取消</Button>
                <Button type="primary" @click="confirm">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import filter from '@/api/filter';
export default {
    props: ['getList'],

    components: {
        selectTree
    },

    data() {
        return {
            formData: {
                supervise:'',
                dataType: '',
                dataOrgIds:[]
            },
            visible: false,
            buzOrganId: '',
            id: null,
            showMenu: false,
            treeData:[],//单独设置机构树
            nullDataType:false,
        };
    },

    methods: {
        open(data) {
            this.visible = true;
            this.nullDataType = false;
            this.buzOrganId = data.buzOrganId;
            this.formData.dataType = data.dataType;
            this.formData.account = data.account;
            this.formData.supervise = data.supervise;
            this.id = data.id;
            if (data.dataType == 1) {
                this.formData.dataOrgIds = [data.buzOrganId];
            } else {
                this.formData.dataOrgIds = data.dataOrgIds ? data.dataOrgIds.split(',') : [];
            }
            if(!data.dataType){
                this.nullDataType = true;
                this.formData.dataType = '2';
            }
            this.$nextTick(() => {
                this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true, data.buzOrganId);
            });
        },

        getTreeData(treeData){
            this.treeData = treeData;
            this.deepCheck(treeData);

            // dataType为空回显所有下拉数据
            if(this.nullDataType){
                this.formData.dataOrgIds = filter.treeFlatArr(this.treeData).map(item=>item.id);
                this.$nextTick(() => {
                    this.$refs.selectTreeRef && this.$refs.selectTreeRef.setSelectIdByChecked();
                });
            }
        },
        deepCheck(treeData) {
            treeData.forEach(item=>{
                item.checked = true;
                if(item.children.length){
                    this.deepCheck(item.children)
                }
            })
        },
        // 权限勾选
        treeClick(data){
            if(data.checked){
                if(this.treeData[0].id != data.id){//当前节点不是顶级的直接子级
                    this.findTreeParent(this.treeData, data.parentId);
                }
                this.findTreeList([data], true);//勾选子级
            }else{
                this.findTreeList([data], false);//去掉子级勾选
            }
            this.$refs.selectTreeRef.setSelectIdByChecked();
        },
        findTreeParent(tree, id){
            tree.find(item=>{
                if(item.id == id){
                    this.$set(item, 'checked', true)
                    if(!item.isTop){//存在非顶级继续查找
                        return this.findTreeParent(this.treeData, item.parentId);
                    }else{
                        return true;
                    }
                }
                if(item.children&&item.children.length){
                    return this.findTreeParent(item.children, id)
                }
                return false;
            })
        },
        findTreeList(tree, checked){
            tree.forEach(item=>{
                this.$set(item, 'checked', checked)
                if(item.children&&item.children.length){
                    this.findTreeList(item.children, checked)
                }
            })
        },

        // 选择数据权限类型
        changeOrgSetUp(value) {
            // 本机构
            if (value == 2) {
                this.$nextTick(() => {
                    this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true, this.buzOrganId);
                });
            }
        },

        confirm() {
            this.$refs.form.validate().then(isOk => {
                if (!isOk) {
                    return;
                }
                const data = {
                    id: this.id,
                    dataType: this.formData.dataType,
                    dataOrgIds: this.formData.dataType == '1' ? this.buzOrganId : this.formData.dataOrgIds.join(','),
                    supervise: this.formData.supervise
                };
                // 开启简洁模式
                if(this.formData.supervise == '1'){
                    this.$notice.inquiry('开启简洁模式后，非监管数据隐藏，开启后本账号无法退出，需要其他账号协助退出，请确认是否开启?').then(async () => {
                        this.$http({
                            url: '/buz/usersExt/upDataPerm',
                            type: 'POST',
                            data,
                            apiPermissionCode:'org_10_6'
                        }).then(res => {
                            this.$Message.success('修改成功');
                            this.getList();
                            this.visible = false;
                        });
                    }).catch(() => {
                        data.supervise = '0';
                        this.$http({
                            url: '/buz/usersExt/upDataPerm',
                            type: 'POST',
                            data,
                            apiPermissionCode:'org_10_6'
                        }).then(res => {
                            this.$Message.success('修改成功');
                            this.getList();
                            this.visible = false;
                        });
                    })
                }else{
                    data.supervise = '0';
                    this.$http({
                        url: '/buz/usersExt/upDataPerm',
                        type: 'POST',
                        data,
                        apiPermissionCode:'org_10_6'
                    }).then(res => {
                        this.$Message.success('修改成功');
                        this.getList();
                        this.visible = false;
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.user-name {
    display: block;
    font-size: 13px;
    margin-top: 1px;
}
.label {
        position: relative;
        .tip-icon {
            margin-left: 6px;
            width: 15px;
            height: 15px;
            border-radius: 15px;
            background: transparent;
            border: 1px solid #ccc;
            color: #ccc;
            display: inline-block;
            text-align: center;
            line-height: 14px;
            font-size: 14px;
            cursor: pointer;
            top: 50%;
        }
        .tip-icon:hover + .pop-tip {
            opacity: 0.9;
            z-index: 9999;
            display: block;
        }
        .pop-tip {
            position: absolute;
            width: 440px;
            top: -60px;
            display: flex;
            align-items: center;
            text-align: left;
            left: 50%;
            margin-left: -50px;
            padding: 9px 10px;
            display: flex;
            flex-direction: column;
            background-color: #444444;
            display: none;
            border-radius: 4px;
            span {
                font-size: 12px;
                font-weight: 500;
                color: #fff;
            }
            .arrow {
                position: absolute;
                width: 12px;
                height: 12px;
                background-color: #444444;
                opacity: 0.9;
                bottom: -4px;
                left: 74px;
                transform: rotateZ(135deg);
            }
        }
    }
</style>
